import { render, staticRenderFns } from "./InlineLabel.vue?vue&type=template&id=9146e8a0"
import script from "./InlineLabel.vue?vue&type=script&lang=js"
export * from "./InlineLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports